// extracted by mini-css-extract-plugin
module.exports = {"container":"_3HIaU4_YdWOiSSzlBFftld","heading":"_2b5jzVQ8MeEHtutN4qomCn","headingText":"KT19_7tV9S7J6rTF9bUV6"};